import {
  STORAGE_AUTH_USER_KEY,
} from '@/store/auth/auth.state';
import enums from '@/enums';

const user = JSON.parse(window.localStorage.getItem(STORAGE_AUTH_USER_KEY) || null);

let url = enums.AppLinks.API;

if (!url) {
  if (process.env.VUE_APP_ENV === enums.AppEnvironments.PRODUCTION) {
    url = 'https://grapeperks.io/api';
  } else if (process.env.VUE_APP_ENV === enums.AppEnvironments.STAGING) {
    url = 'https://staging.grapeperks.io/api';
  } else {
    //Fix Nov 5----------------------------------------------------------
    // url = 'http://localhost:3000';
    //----------------------------------------------------------
    // Development: Automatically detect hostname
    // Works with localhost:8000 → localhost:3000
    // Works with 192.168.x.x:8000 → 192.168.x.x:3000
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    url = `${protocol}//${hostname}:3000`;
    //----------------------------------------------------------
  }
}

const configApi = {
  url,
  timeout: 0,
  token: null,
  refreshToken: null,
  userId: user ? user.id : null,
  limitApiCalls: process.env.VUE_APP_LIMIT_API_CALLS
    ? process.env.VUE_APP_LIMIT_API_CALLS.toLowerCase() === 'true'
    : true,
  fakeDb: process.env.VUE_APP_FAKE_DB
    ? process.env.VUE_APP_FAKE_DB.toLowerCase() === 'true'
    : false,
  baseRoutesUrls: {
    appServices: '/app-services',
    appServiceCountries: '/app-service-countries',
    appSettings: '/app-settings',
    attributes: '/contacts/attributes',
    auth: '/auth',
    callerIds: '/sms/dedicated-numbers',
    contacts: '/contacts',
    feedback: '/feedback',
    inboundSms: '/sms/inbox',
    notifications: '/notifications',
    segments: '/contacts/segments',
    smsCampaigns: '/sms/campaigns',
    smsTemplates: '/sms/templates',
    stripe: '/stripe',
    tags: '/contacts/tags',
    tenants: '/tenants',
    users: '/users',
    userSettings: '/settings',
    waitingList: '/waitlist',
    reviews: '/reviews',
    imports: '/import-jobs',

    mmsTemplates: '/mms-templates',
    emailTemplates: '/email-templates',
    recordings: '/recordings',
    mailerIds: '/mailer-ids',
    mmsCampaigns: '/mms-campaigns',
    voiceCampaigns: '/voice-campaigns',
    emailCampaigns: '/email-campaigns',
    audiences: '/audiences',
  },
};

export default configApi;
